import { Form, InputNumber, Typography } from "antd";
import { useEffect } from "react";
import { FluxoResposta } from "../cadastroCotaUsuario.types";
import { OnboardingFrame, SubmitButton } from "../utils";

interface Props {
  fluxo: FluxoResposta;
  submitting: boolean;
  onConcluir: (payload: Record<string, unknown>) => Promise<void>;
}

const formatarMoeda = (valor: number) =>
  valor.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

export function EtapaValorVenda({ fluxo, submitting, onConcluir }: Props) {
  const [form] = Form.useForm();
  const detalhes = fluxo.detalhesEtapa;
  const vendaSalva = fluxo.dadosPreenchidos?.venda as Record<string, unknown> | undefined;
  const possuiSaldoDevedor = detalhes?.possuiSaldoDevedor ?? vendaSalva?.possuiSaldoDevedor === true;
  const saldoDevedor = Number(detalhes?.saldoDevedor ?? vendaSalva?.saldoDevedor ?? 0);
  const salvo = vendaSalva ?? (fluxo.dadosPreenchidos?.valorVenda as Record<string, unknown> | undefined);

  useEffect(() => { form.setFieldsValue(salvo); }, [form, salvo]);

  return (
    <OnboardingFrame
      fluxo={fluxo}
      title={possuiSaldoDevedor ? "Quanto você gostaria de receber pela transferência da sua cota?" : "Por quanto você gostaria de vender sua cota?"}
      description={possuiSaldoDevedor ? "Além desse valor, o comprador deverá assumir o saldo devedor informado da cota." : "Informe o valor que pretende receber pela venda. Você poderá alterá-lo posteriormente."}
    >
      <Form layout="vertical" form={form} initialValues={salvo} onFinish={onConcluir}>
        <Form.Item
          name="valorVenda"
          label={possuiSaldoDevedor ? "Valor que deseja receber" : "Valor de venda"}
          rules={[{ required: true, message: "Informe o valor da venda." }]}
        >
          <InputNumber prefix="R$" min={0} style={{ width: "100%" }} decimalSeparator="," placeholder="0,00" />
        </Form.Item>

        {possuiSaldoDevedor ? (
          <Form.Item noStyle shouldUpdate={(prev, next) => prev.valorVenda !== next.valorVenda}>
            {({ getFieldValue }) => {
              const valorVenda = Number(getFieldValue("valorVenda") || 0);
              return (
                <>
                  <Typography.Paragraph>
                    <Typography.Text strong>Saldo devedor informado: {formatarMoeda(saldoDevedor)}</Typography.Text><br />
                    <Typography.Text type="secondary">Esse valor será apresentado separadamente ao interessado.</Typography.Text>
                  </Typography.Paragraph>
                  {valorVenda > 0 ? (
                    <Typography.Paragraph>
                      <Typography.Text strong>Valor que você deseja receber</Typography.Text><br />
                      {formatarMoeda(valorVenda)}<br /><br />
                      <Typography.Text strong>Saldo devedor a ser assumido pelo comprador</Typography.Text><br />
                      {formatarMoeda(saldoDevedor)}<br /><br />
                      <Typography.Text strong>Valor total estimado da aquisição</Typography.Text><br />
                      <Typography.Text strong>{formatarMoeda(valorVenda + saldoDevedor)}</Typography.Text>
                    </Typography.Paragraph>
                  ) : null}
                </>
              );
            }}
          </Form.Item>
        ) : null}
        <SubmitButton label="Continuar" loading={submitting} />
      </Form>
    </OnboardingFrame>
  );
}
